import { BaseTour } from "@src/widgets/onboarding/classes/BaseTour"
import { PaymentsLinkStep } from "@src/widgets/onboarding/classes/tours/SendingInvoicesTour/steps/PaymentsLinkStep"
import { ONBOARDING_TOURS } from "@src/widgets/onboarding/types"

export class SendingInvoicesTour extends BaseTour {
  name = ONBOARDING_TOURS.SENDING_INVOICES

  steps = [new PaymentsLinkStep()]
}
